import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import UnitBoxLoader from './UnitBoxLoader';
import { useAuth } from '../../../Contexts/AuthProvider';
import UnitBoxDataError from './UnitBoxDataError';
import useUnitLastChannelsData from '../../../Hooks/useUnitLastChannelsData';
import UnitBoxDigitalViewHeader from './UnitBoxDigitalViewHeader';
import UnitDigitalViewCard from './UnitDigitalViewCard';
import { useBoxes } from '../../../Contexts/BoxContext';
import { boxHelper } from '../../../helpers';
import UnitBoxDigitalViewSignalR from '../../SignalrSubscribes/UnitBoxDigitalViewSignalR';

const UnitBoxDigitalView = props => {

    const {
        boxData,
        onRemove,
        handleEdit,
        dragHandleProps,
        onNewWindowOpen,
        onExportToCsv,
        section = 'unit',
    } = props;

    const {
        unitUid,
        channels,
        filters,
    } = boxData;

    const { token, currentCompany } = useAuth();
    const { currentUnitModel, unitCodeColors, startDate, endDate } = useBoxes();
    const [data, setData] = useState([]);
    const [hasDataError, setHasDataError] = useState(false);
    const signalrRequestBody = useMemo(() => ({ uId: unitUid, channels, ...filters, jobType: section }), [unitUid, channels, filters, section]);

    const channelsDataUnitRequest = useUnitLastChannelsData({ unitUid, channels, filters, section, startDate,  endDate});

    useEffect(() => {
        if (channelsDataUnitRequest.isSuccess) {
            setHasDataError(false);
            try {
                //**sync channels with colors**
                const channelColorMap = {};
                let hasChannelWithoutColor = false;
                channels.forEach((channel) => {
                    const color = boxHelper.colors(channel.dmsId, unitCodeColors);
                    if (color) {
                        channelColorMap[channel.code] = color;
                    } else {
                        hasChannelWithoutColor = true;
                    }
                });

                if (hasChannelWithoutColor) return;
                //**sync channels with colors - end**

                const { channelDataResponses } = channelsDataUnitRequest.data;

                if (channelDataResponses) {
                const serverData = channels.map(ch => {
                    const foundCh = channelDataResponses.find(channel => channel.channel.code === ch.code);
                    const channelValue = foundCh?.data[0]?.value;
                    return {
                        ...ch,
                        value: channelValue,
                        color: channelColorMap[ch.code],
                        unitName: currentUnitModel?.nameLocalized,
                        unitCode: currentUnitModel?.uId,
                        unit: ch.unit || currentUnitModel?.unit,
                    };
                });
                    setData(serverData);
                } else {
                    setData([])
                    setHasDataError(true);
                }
            } catch (e) {
                console.log(e)
                setHasDataError(true);
            }

        }
    }, [
        channelsDataUnitRequest.data,
        channelsDataUnitRequest.isSuccess,
        channels,
        unitCodeColors,
        currentUnitModel,
    ]);
  

    const handleLiveData = useCallback(incomingData => {
        if (!incomingData || !incomingData.length) {
            setData([]);
            return;
        }
        if (incomingData && incomingData.length) {
            const allowedIds = new Set(channels.map(ch => String(ch.id)));
            const filteredIncoming = incomingData.filter(d => allowedIds.has(String(d.channelId)));
            
            if (filteredIncoming.length === 0) return;

            setData(prevData => {
                const newData = [];

                filteredIncoming.forEach(channelData => {
                    const { channelId, value, nameLocalized, dmsId } = channelData;
                    const channelIdKey = String(channelId);

                    const existingChannel = prevData.find(item => String(item.id) === channelIdKey);
                    
                    const originalChannel = channels.find(ch => String(ch.id) === channelIdKey);
                    
                    let color = existingChannel?.color;
                    if (!color && originalChannel) {
                        color = boxHelper.colors(originalChannel.dmsId, unitCodeColors);
                    }
                    if (!color && dmsId != null) {
                        color = boxHelper.colors(dmsId, unitCodeColors);
                    }
                    
                    if (newData.every(item => String(item.id) !== channelIdKey)) {
                        newData.push({ 
                            id: originalChannel?.id ?? channelId, 
                            value: value || 0, 
                            unitName: currentUnitModel?.nameLocalized,
                            unitCode: currentUnitModel?.uId,
                            nameLocalized: nameLocalized,
                            color: color,
                            unit: originalChannel?.unit || currentUnitModel?.unit,
                        });
                    } else {
                        const channelIndexFromExistingData = newData.findIndex(item => String(item.id) === channelIdKey);
                        if (channelIndexFromExistingData !== -1) {
                            newData[channelIndexFromExistingData].value = value || 0;
                            if (!newData[channelIndexFromExistingData].color && color) {
                                newData[channelIndexFromExistingData].color = color;
                            }
                        }
                    }
                });
                return newData;
            });
        }
    }, [currentUnitModel?.code, currentUnitModel?.nameLocalized, currentUnitModel?.unit, unitCodeColors, channels]);

    // const handleLiveData = useCallback(incomingData => {
    //     console.log('incoming', incomingData);
    //     if (incomingData && incomingData.length) {
    //         setData(data => {
    //             const newData = incomingData ? [...incomingData] : [];
    //             // console.log('pre', newData);
    //             incomingData.forEach(channelData => {
    //                 const { channelId, value } = channelData;
                       
    //                 // console.log(channelData);
    //                 const channelIndexFromExistingData = newData.findIndex(item => item.id === channelId);

    //                 if (channelIndexFromExistingData !== -1) {
    //                     newData[channelIndexFromExistingData].value = value || 0;
    //                 }
    //             });
    //             console.log('new data', newData);
    //             return newData;
    //         });
    //     }

    // }, [setData]);

    // const handleLiveData = useCallback(incomingData => {
    //     if (incomingData && incomingData.length) {
    //         setData(prevData => {
    //             const updatedData = [...prevData];
    //             incomingData.forEach(liveDataItem => {
    //                 const index = updatedData.findIndex(item => item.id === liveDataItem.channelId);
    //                 if (index !== -1) {
    //                     updatedData[index] = {
    //                         ...updatedData[index],
    //                         value: liveDataItem.value,
    //                         unitName: currentUnitModel?.nameLocalized,
    //                         unitCode: currentUnitModel?.code,
    //                     };
    //                 }
    //             });
    //             return updatedData;
    //         });
    //     }
    // }, [setData, currentUnitModel]);
    

    return (
        <Fragment>
            <UnitBoxLoader
                loading={channelsDataUnitRequest.isLoading || channelsDataUnitRequest.isFetching}
            />

            <UnitBoxDigitalViewHeader
                box={boxData}
                onRemove={onRemove}
                handleEdit={handleEdit}
                dragHandleProps={dragHandleProps}
                onManageAxesSettings={() => {
                }}
                onNewWindowOpen={onNewWindowOpen}
                onExportToCsv={onExportToCsv}
            />

            <div className="pageCard">
                {
                    hasDataError
                        ? <UnitBoxDataError />
                        : <UnitDigitalViewCard data={data} />
                }
            </div>

            <UnitBoxDigitalViewSignalR
                token={token}
                companyId={currentCompany?.id}
                requestBody={signalrRequestBody}
                onIncomingData={handleLiveData}
            />
        </Fragment>
    );
};

export default UnitBoxDigitalView;
